import React from 'react';

const LoadingRow = ({ message }) => (
  <div className="card w-full min-w-0 overflow-hidden">
    <div className="p-4 md:p-6 flex items-center gap-3 text-gray-700">
      <div className="animate-spin rounded-full h-5 w-5 border-b-2 border-indigo-500 shrink-0" />
      <div className="text-xs sm:text-sm min-w-0">{message}</div>
    </div>
  </div>
);

export default LoadingRow;
